import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import { TextField, InputAdornment, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import ListContainer from '../../sharedcomponents/listContainer/listContainer';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import Helper from '../../utility/helper';

const SelectModule = (props) =>
{
    const moduleList = useState([]);
    const moduleFilterList = useState([]);
    const selectModuleList = useState([]);
    const searchField = useState('');
    const eventInfo = useState(null);
    const userInfo = useState(null);
    const loading = useState(true);
    const getModuleList = () =>
    {
        ApiHelper.get(APIURLConstants.GET_MODULE_LIST)
            .then((res) =>
            {
                if (props.moduleEventList.length > 0)
                {
                    const results = res.data.filter(
                        ({ moduleID: id1 }) =>
                            !props.moduleEventList
                                .get()
                                .some(({ moduleID: id2 }) => id2 === id1)
                    );

                    moduleList.set(results);
                    moduleFilterList.set(results);
                } else
                {
                    moduleList.set(res.data);
                    moduleFilterList.set(res.data);
                }

                loading.set(false);
            })
            .catch((error) =>
            {
                loading.set(false);
                if (error.response && error.response.status === 401)
                {
                    alert(error);
                }
            });
    };

    useEffect(() =>
    {
        const userEventInfo = Helper.getStorage('eventInfo');
        const guserInfo = Helper.getStorage('userInfo');
        eventInfo.set(userEventInfo);
        userInfo.set(guserInfo);
        getModuleList();
    }, []);

    const setSelectModule = (value) =>
    {
        selectModuleList.set(JSON.parse(JSON.stringify(value)));
    };

    const handleClick = () =>
    {

        if (selectModuleList.get().length == 0)
        {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please Select Module',
            });
        } else
        {
            let requestObj = {
                modules: [],
            };
            selectModuleList
                .attach(Downgraded)
                .get()
                .forEach((item) =>
                {
                    requestObj.modules.push({
                        eventModuleID: 0,
                        eventID: eventInfo.attach(Downgraded).get().eventID,
                        moduleID: item,
                        order: 1,
                        status: 1,
                        createdBy: userInfo.attach(Downgraded).get().userID,
                    });
                });

            ApiHelper.post(APIURLConstants.POST_MODULES, requestObj)
                .then((res) =>
                {
                    if (res.data > 0)
                    {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Module added successfully',
                        });
                        props.handleClose();
                        props.handleAction();
                    }
                })
                .catch((error) =>
                {
                    console.log('error : ', error);
                    let message = '';
                    if (error.response && error.response.status === 401)
                    {
                        message = 'Access denied';
                    } else
                    {
                        message = 'Error while adding Module';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                    // props.handleClose();
                    // props.getParticipants();
                });
            //props.handleClose();
        }
    };

    const handleSearch = (e) =>
    {
        searchField.set(e.target.value);
        let filterStore = [];
        if (e.target.value && moduleList.get())
        {
            filterStore = moduleList
                .get()
                .filter(
                    (o) =>
                        o.moduleName
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase()) ||
                        o.displayName
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                );
            moduleFilterList.set(filterStore);
        } else
        {
            moduleFilterList.set(JSON.parse(JSON.stringify(moduleList.get())));
        }
    };
    const renderDialogContent = () =>
    {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <TextField
                    sx={{ pb: 2 }}
                    value={searchField.value}
                    onChange={handleSearch}
                    size="small"
                    fullWidth={true}
                    placeholder="Search Modules"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
                <ListContainer
                    loading={loading.value}
                    data={moduleFilterList.get()}
                    setSelectModule={setSelectModule}
                />
            </Box>
        );
    };
    const renderDialogActions = () =>
    {
        return (
            <ButtonContainer
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={'Add'}
            />
        );
    };
    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            maxWidth={'sm'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

export default SelectModule;
